/*
 * File: /src/store/modules/groups.js
 * Created Date: Thursday May 30th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 30th May 2019 11:25:24 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import conditionService from 'src/services/conditionServices';

const state = {
  conditionConfig: undefined,
};

const getters = {
  getConditionConfig: (state) => state.conditionConfig,
};

const actions = {
  fetchConditionConfig({ commit }) {
    if (state.conditionConfig == undefined) {
      return conditionService.getConditionConfig().then((response) => {
        commit('setConditionConfig', response.data);
      });
    }
  },
  unloadConditionConfig({ commit }) {
    commit('setConditionConfig', undefined);
  },
};

const mutations = {
  setConditionConfig(state, config) {
    state.conditionConfig = Object.assign({}, config);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
